module.exports = __webpack_public_path__ + "634513dc791352157f12cb0a5ed8782b.woff";


//////////////////
// WEBPACK FOOTER
// ./bower_components/footable/css/fonts/footable.woff
// module id = 484
// module chunks = 1